import { Stack, Typography, Theme } from '@mui/material';
import { UserBalanceProps } from './types';
import { useTranslation } from 'react-i18next';

export const UserBalance: React.FC<UserBalanceProps> = ({ amount, held }) => {
  const { t } = useTranslation();
  const hasHeld = typeof held === 'number' && held > 0;
  return (
    <Stack direction="column" sx={{ gap: '12px' }} alignItems="center">
      <Typography variant="body2" color="common.white">
        {t('cabinetPage.yourBalanceText')}:
      </Typography>
      <Typography
        variant="h1"
        color="common.white"
        sx={{ fontSize: '64px', lineHeight: '80%' }}
      >
        {amount} <span style={{ fontSize: '24px' }}>₴</span>
      </Typography>
      {hasHeld && (
        <Stack alignItems="center" sx={{ gap: '2px', mt: '4px' }}>
          <Typography
            sx={(theme: Theme) => ({
              fontSize: 15,
              fontWeight: 700,
              color: theme.palette.orange.main,
            })}
          >
            {held.toFixed(2)} ₴ {t('cabinetPage.heldLabel')}
          </Typography>
          <Typography sx={{ fontSize: 12, color: 'gray.50' }}>
            {t('cabinetPage.heldForCharging')}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
